module.exports = __webpack_public_path__ + "static/media/galerija_2022_0053.d7ead591.jpg";